export const viewportCameraKeys = [
  "frontLeftAerial",
  "frontRightAerial",
  "backLeftAerial",
  "backRightAerial",
  "frontSidewalk",
] as const;

export type ViewportCameraKey = (typeof viewportCameraKeys)[number];

export function isViewportCameraKey(value: string): value is ViewportCameraKey {
  return viewportCameraKeys.includes(value as ViewportCameraKey);
}

export const builtInSheetCameraKeys = [
  "topRightPerspectiveCamera",
  "topLeftPerspectiveCamera",
  "bottomRightPerspectiveCamera",
  "bottomLeftPerspectiveCamera",
  "defaultExteriorCamera",
] as const;

export type BuiltInSheetCameraKey = (typeof builtInSheetCameraKeys)[number];
